import React, { useContext, useState, useEffect } from 'react'
import { name as getCountryName } from 'iso-3166-country-list'
import { useParams, useHistory } from 'react-router-dom'
import { useQuery, useMutation } from '@apollo/client'

import { MUTATION, QUERY } from '../../apollo'
import TrackContext from '../../context/TrackContext'
import DetailItem from './DetailItem'
import * as Icon from '../Icons'
import Tracks from './Tracks'
import Chat from './Chat'
import PurchasedExtraItems from './PurchasedExtraItems'

import styles from './detail.module.css'

function RequestItem({ kind = 'quote' }) {
  const { data } = useQuery(QUERY.USER_INFO)
  const userInfo = data?.userInfo
  let { itemId } = useParams()
  let history = useHistory()

  const { setPlayerTrack, filterTracks, playerTrack } = useContext(TrackContext)
  const [selectedInfo, setSelectedInfo] = useState(null)

  const [updateValue] = useMutation(MUTATION.UPDATE_VALUE, {
    onError: (error) => {
      console.log(error.graphQLErrors[0].message)
    },
    refetchQueries: [{ query: QUERY.USER_INFO }],
  })

  const [updateMessages] = useMutation(MUTATION.UPDATE_MESSAGES, {
    onError: (error) => {
      console.log(error.graphQLErrors[0].message)
    },
    refetchQueries: [{ query: QUERY.USER_INFO }],
  })

  useEffect(() => {
    if (userInfo) {
      const info = userInfo[kind].find(({ id }) => itemId === id)

      if (info) {
        setSelectedInfo(info)
        if (kind === 'purchased') {
          setPlayerTrack({
            artist: info.trackArtist,
            name: info.trackName,
            slug: info.trackSlug,
          })
          filterTracks([])
        }
        if (info.tracks && info.tracks.length > 0) {
          filterTracks(info.tracks)
        }
      } else {
        history.replace('/profile')
      }
    }
  }, [userInfo, kind, itemId, setPlayerTrack, filterTracks, history])

  async function updateHandler({ ...values }) {
    await updateValue({
      variables: { requestId: itemId, requestType: 'purchased', input: values },
    })
  }

  const foundParentRequest =
    selectedInfo && selectedInfo.refRequestType
      ? userInfo[selectedInfo.refRequestType]
        ? userInfo[selectedInfo.refRequestType].find(
            ({ id }) => id === selectedInfo.refRequestId
          )
        : false
      : false

  async function messenger(message) {
    try {
      if (selectedInfo) {
        await updateMessages({
          variables: {
            requestType:
              kind === 'purchased'
                ? foundParentRequest
                  ? selectedInfo.refRequestType
                  : 'purchased'
                : kind,
            requestId:
              kind === 'purchased'
                ? foundParentRequest
                  ? selectedInfo.refRequestId
                  : selectedInfo.id
                : selectedInfo.id,
            message,
          },
        })
      }
    } catch (err) {
      console.log({ err })
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <h2 className={styles.mainHeading}>
          <Icon.MusicQuote className={styles.mainHeadingIcon} /> {kind}
        </h2>
        {userInfo && selectedInfo && (
          <>
            <div className={styles.detailItemsList}>
              <DetailItem value={itemId} label="Id" className={styles.idItem} />
              <DetailItem value={selectedInfo.date} label="Creation Date" />
              <DetailItem
                value={selectedInfo.licenseUser}
                label="License User"
              />
              <DetailItem value={selectedInfo.style} label="Music Style" />
              <DetailItem value={selectedInfo.reference} label="Reference" />
              <DetailItem value={selectedInfo.vocals} label="Vocals" />
              <DetailItem value={selectedInfo.media} label="Media" />
              <DetailItem
                value={selectedInfo.projectType}
                label="Type of project"
              />
              <DetailItem value={selectedInfo.paidMedia} label="Paid Media" />
              <DetailItem value={selectedInfo.territory} label="Territory" />
              <DetailItem
                value={selectedInfo.country}
                label="Country"
                predicate={getCountryName}
              />
              <DetailItem value={selectedInfo.duration} label="Duration" />
              <DetailItem value={selectedInfo.typeOfUse} label="Type of Use" />
              <DetailItem
                value={selectedInfo.licensingTerm}
                label="Licensing Term"
              />
              <DetailItem
                value={selectedInfo.typeOfLicense}
                label="Type of License"
              />
              <DetailItem value={selectedInfo.extraInfo} label="Extra Info" />
              <DetailItem
                value={selectedInfo.trackArtist}
                label="Track Artist"
              />
              <DetailItem value={selectedInfo.trackName} label="Track Name" />
              <DetailItem value={selectedInfo.trackPrice} label="Track Price" />
              <DetailItem value={selectedInfo.publisher} label="Publisher" />
              <DetailItem value={selectedInfo.label} label="Label" />

              <DetailItem
                value={selectedInfo.projectName}
                label="Project Name"
                updateHandler={(projectName) => updateHandler({ projectName })}
                editable={kind === 'purchased'}
                key={`ProjectName_${itemId}`}
              />

              {kind === 'purchased' && (
                <PurchasedExtraItems
                  selectedInfo={selectedInfo}
                  updateHandler={updateHandler}
                  userId={userInfo.id}
                  key={itemId}
                  hasParent={foundParentRequest}
                  invoiceReady={
                    userInfo.billingInfo &&
                    userInfo.billingInfo.country &&
                    userInfo.billingInfo.name
                  }
                />
              )}
            </div>
            <Tracks
              tracks={selectedInfo.tracks}
              requestType={kind}
              requestId={itemId}
              playerTrack={playerTrack}
              setPlayerTrack={setPlayerTrack}
            />
          </>
        )}
      </div>
      {userInfo && selectedInfo && (
        <Chat
          messages={
            kind === 'purchased'
              ? selectedInfo.refRequestType
                ? foundParentRequest
                  ? foundParentRequest.messages
                  : selectedInfo.messages
                : []
              : selectedInfo.messages
          }
          type={
            kind === 'purchased'
              ? foundParentRequest
                ? selectedInfo.refRequestType
                : 'purchased'
              : kind
          }
          sendMessage={messenger}
          username={userInfo.name}
        />
      )}
    </div>
  )
}

export default RequestItem
